<template>
    <main class="inner-layout">
        <Navigation v-if="user" class="inner-layout__navigation-desktop"/>
        <div class="inner-layout__inner">
            <Header/>
            <div class="inner-layout__views">
                <slot/>
            </div>
            <div class="container container_size_full">
                <Footer class="inner-layout__footer"/>
            </div>
        </div>
    </main>
</template>

<script setup>
import Footer from "@/components/UI/footer/Footer.vue";
import Header from "@/components/UI/header/index.vue";
import Navigation from "@/components/UI/navigation/index.vue";
import {computed} from "vue";
import {useStore} from "vuex";

const store = useStore()
const user = computed(() => store.getters.user)
</script>

<style scoped lang="scss">
.default {
    background-color: #F0F0F0;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 56px;
        background-color: #fff;
        padding: 0 12px;
        @media only screen and (min-width: 744px) {
            min-height: 72px;
            padding: 0 24px;
        }
    }

    &__logo {
        width: 105px;
        height: 34px;
        @media only screen and (min-width: 744px) {
            width: 146px;
            height: 48px;
        }
    }

    &__row {
        display: flex;
    }

    &__lang {
        margin-right: 12px;
    }

    &__entry {
        padding: 12px;
    }

    &__icon {
        @media only screen and (min-width: 744px) {
            margin-right: 6px;
        }
    }
}
</style>
